import { IDataContainerService } from "app/interfaces/data-container.interface";

export function showIfEAgency(record: any, dataActionContainerService: IDataContainerService): boolean{
	return dataActionContainerService.getDomainSetting('enabled_modules.eagency.enabled') == true;
}

export function skipIfNotEAgency(record: any, dataActionContainerService: IDataContainerService): boolean{
	return dataActionContainerService.getDomainSetting('enabled_modules.eagency.enabled') != true;
}